import Vue from 'vue'
import util from '../util'

// NOTE: pagination isn't supported on the site now, so crank up query hits.hits size to 1000
const MAX_REQUEST_SIZE = 1000

const EXCLUDE_HIDDEN = 'AND NOT flags.hide-from-search:true'

function escapeCategory (cat) {
  // escape category / subcategory,
  // including escaping any spaces with backslash for ES URI API
  if (!cat) {
    return cat
  }
  return encodeURIComponent(cat).replace(/%20/g, '\\%20')
}

class ProtocolsDB {
  constructor () {
    this.baseUrl = 'https://search-protocol-library-vtnb4isrcwl533qbttgesbtmny.us-west-2.es.amazonaws.com/'
    this.protocolsIndexUrl = this.baseUrl + util.appendBranchSuffix('protocols') + '/protocol/'
    this.protocolsIndexSearchUrl = this.baseUrl + util.appendBranchSuffix('protocols') + '/protocol/_search/'
    this.categoriesIndexUrl = this.baseUrl + util.appendBranchSuffix('categories') + '/category/'
  }

  getCategories () {
    return Vue.http
      .get(this.categoriesIndexUrl + '0')
      .then((response) => {
        return response.data
      })
  }

  getFeaturedProtocols () {
    return Vue.http
      .get(this.protocolsIndexSearchUrl, {params: {q: 'flags.feature:true ' + EXCLUDE_HIDDEN}})
      .then((response) => {
        return response.data.hits.hits
      })
  }

  queryProtocols (query) {
    return Vue.http
      .get(this.protocolsIndexSearchUrl, {params: {q: `${query} ${EXCLUDE_HIDDEN}`, size: MAX_REQUEST_SIZE}})
      .then((response) => {
        return response.data.hits.hits
      })

    // TODO: Vue's 'vue-resource' has http.get fn that doesn't let you
    // send a body in a GET. If it did, you could do a better search like this:
    //
    // return Vue.http
    //   .get(this.protocolsIndexSearchUrl, {
    //     body: {
    //       size: MAX_REQUEST_SIZE,
    //       multi_match: {
    //         query: query,
    //         fields: ['title^3', 'notes', 'description', 'process']
    //       }
    //     }
    //   })
    //   .then((response) => {
    //     return response.data.hits.hits
    //   })
  }

  getProtocol (protocolSlug) {
    return Vue.http
      .get(this.protocolsIndexUrl + protocolSlug)
      .then((response) => response.data._source)
  }

  getProtocolsByCategory (rawCategory, rawSubCategory) {
    let query = null
    const category = escapeCategory(rawCategory)
    const subCategory = escapeCategory(rawSubCategory)

    if (category && subCategory) {
      // exact subCategory match
      query = `(categories.${category}:"${subCategory}")`
    } else if (category) {
      query = `(categories.${category})`
    } else {
      console.error('Must provide category (and optionally) subcategory argument')
      query = '*'
    }
    // NOTE: I'm not using get's {params: } config here b/c it auto-escapes URIs
    // and ruins the space characters
    return Vue.http
      .get(this.protocolsIndexSearchUrl + `?q=${query} ${EXCLUDE_HIDDEN}&size=${MAX_REQUEST_SIZE}`)
      .then((response) => response.data.hits.hits)
  }
}

export default new ProtocolsDB()



// WEBPACK FOOTER //
// ./src/store/db.js